<template>
    <div class="cs-forgot-password">
		<div class="box">
            <div class="content">
				<div class="text-center">
					<img class="mb-4" src="img/logo-login.png" alt="logo go fix">
					<div v-if="!is_message_sent" class="desc-below-logo">Type in your email address to reset your<br/> password easily</div>
					<div v-else class="message-sent-success">{{message_sent}}</div>
				</div>
                <b-form v-if="!is_message_sent" class="form-vertical login-form formV2" autocomplete="off">
                    <div class="alert fade in alert-danger" style="display: none;"> <i class="icon-remove close" data-dismiss="alert"></i> Enter any username and password. </div>
                    <gofix-form-input 
						@enter="onEnterClick"
						v-model="$v.email.$model" 
						class="mb-3" 
						label="Email" 
						desc="e.g. user@gmail.com" 
						type="email" required>
					</gofix-form-input>
                    <div class="form-actions">
                        <gofix-button label="Reset Password" :loading="isAction" @click="getUserExists" type="button" variant="primary" class="submit btn pull-right"></gofix-button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>

	import { validationMixin } from 'vuelidate'
	import { required, minLength,email } from 'vuelidate/lib/validators'
	import { floatLabel } from '@/_floatLableClass.js'

export default {
  	name: 'ForgotPassword',
  	data () {
      return {
		email:null,
		isAction : false,
		message_sent:'',
		is_message_sent:false
      }
  	},
  	computed: {

  	},
	mixins: [validationMixin],
	validations: {
		email: {
			required,
			email,
		},
	},
	watch: {

	},
  	async created() {
    //this.$router.go();
  	},
    mounted: async function() {
		//document.querySelector('.form-control').addEventListener('animationstart', onAnimationStart, false)
		floatLabel();
	},
	updated: async function() {
		await this.$nextTick();
		await floatLabel()
		//await this.setClassInput();
	},
  	methods:{
		async getUserExists(){
			this.is_message_sent = false;
			this.messsage_sent = '';
			this.$v.$touch()
			if (this.$v.$invalid) {
				return this.$alertNotification("The email you entered is not in the correct format. Please check!.", "danger");;
			}
			this.isAction = true;
			this.$store.dispatch( 'AuthController/checkUserExist', {
				email : this.email.trim()
			})
			.then(async result =>{
					this.message_sent =  result.data.data.message;
					this.is_message_sent = true;
					this.isAction = false;
			})
			.catch(error=>{
				this.isAction = false;
				this.$bvToast.toast('Forgot Password error!', {
					title: `Notification`,
					autoHideDelay: 3000,
					variant: 'danger',
					solid: true
				})
			})
		},
		onEnterClick: function() {
			this.getUserExists();
		}
  	}
}
</script>
<style>
.cs-forgot-password ~ #_goFixLogin{
  display: none !important;
}
</style>
